module.exports = __webpack_public_path__ + "media/images/cover/3-49bcc3fd48b2f8eff1f1f062b99cb08a.jpg";